import {AccessProvider} from '../lib/access.jsx'
import {ToolAccessProvider} from '../lib/toolAccess.jsx'
import {useSessionGeneration} from '../lib/useSessionGeneration.js'

// Remount both the role/book provider and every protected route instance. The
// generation is a local invalidation fence, never a bearer token or a grant.
export function SessionBoundaryView({generation, children}) {
  return <AccessProvider key={generation}><ToolAccessProvider>{children}</ToolAccessProvider></AccessProvider>
}
export default function SessionBoundary({children}) {
  const generation = useSessionGeneration()
  return <SessionBoundaryView generation={generation}>{children}</SessionBoundaryView>
}
